import "./styles.scss";
import React, { useEffect, useState } from "react";
import {
	Col,
	Container,
	Row,
	CardText,
	Breadcrumb,
	BreadcrumbItem,
} from "reactstrap";
import "assets/scss/website/app.scss";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import "nouislider/distribute/nouislider.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CardItem from "./CardItem";
import { toast } from "react-toastify";
import HomeService from "services/Website/HomeService";
import { SuccessOk } from "configs/statusCode";
import CompoundCard from "./CompoundCard";
import SideFilters from "components/Website/SideFilters";
import { Link } from "react-router-dom";
import Navbar from "components/Website/Layouts/Navbar";
import Footer from "components/Website/Layouts/Footer";
import AuthCard from "components/Website/Cards/AuthCard";
import Paginator from "./Paginator";
import { useSelector, useDispatch } from "react-redux";
import filterIcon from "../../../assets/images/filter.svg";
import { authenticate } from "store/Auth/actions";
import { appendFilters } from "store/filter/actions";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import HearForm from "../Home/HearForm";

const AdvancedFilter = (props) => {
	const homeService = new HomeService();
	const dispatch = useDispatch();
	const filterData = useSelector((state) => state.filter);
	const [search, setSearch] = useState(false);
	const [loading, setLoading] = useState(false);
	const [modal, setModal] = useState(false);
	const { t, language } = useTranslation();
	const [filtersParams, setFilterParams] = useState({});
	const [explore, setExplore] = useState(false);
	const [compoundList, setCompoundList] = useState([]);
	const [compareListData, setCompareListData] = useState([]);
	const [ids, setIds] = useState([]);
	const [compounds, setCompounds] = useState([]);
	const [page, setPage] = useState(1);
	const AuthData = useSelector((state) => state.Auth);
	const [pageOptions, setPageOptions] = useState({
		perPage: 6,
		totalSize: 1,
		totalPages: 1,
		page: 1,
		data: [],
	});

	// useEffect(() => {
	//   const idsData = filterData.comparedIds.join()
	//   if (filterData.comparedIds?.length) {
	//     let params = {
	//       ids: idsData
	//     }
	//     homeService.getComparedCompound(params).then(response => {
	//       if (response && response.status === SuccessOk) {
	//         setCompareListData(response.data)
	//       }
	//     })
	//   }
	// }, [])

	useEffect(() => {
		// const timeoutId = setTimeout(() => {
		// setLoading(true)
		if (
			filterData.compound?.label?.trim()?.length ||
			filterData.delivery?.length
		) {
			document.getElementById("compoundNamme").blur();
			document.getElementById("delivery").blur();
		}
		let params = {};
		if (filterData.compound?.type === "developer")
			params["developer_id"] = filterData.compound?.id;
		if (filterData.compound?.type === "compound")
			params["compound_id"] = filterData.compound?.id;
		if (
			filterData.compound?.type !== "developer" &&
			filterData.compound?.type !== "compound"
		)
			params["keyword"] = filterData?.compound?.label?.trim();
		// if (filterData.compound?.type === "developer" && filterData.compound?.type === "compound" && filterData.compound?.label?.trim()?.length) params["keyword"] = filterData.compound?.label?.trim()
		params["budget"] = `${Math.round(filterData.budget[0])}-${Math.round(
			filterData.budget[1]
		)}`;
		params["area_sizs"] = `${Math.round(filterData.size[0])}-${Math.round(
			filterData.size[1]
		)}`;
		if (filterData.country) params["country_ids"] = filterData.country.value;
		if (filterData.location) params["location"] = filterData.location.value;
		if (filterData.paymentMethods?.length)
			params["payment_type"] = filterData.paymentMethods.join();
		if (filterData.categories_ids?.length)
			params["categories_ids"] = filterData.categories_ids
				.map((item) => item.value)
				.join();
		if (filterData.finishingType?.length)
			params["finishing_type_ids"] = filterData.finishingType
				.map((item) => item.value)
				.join();
		if (filterData.unitType?.length)
			params["unit_type_ids"] = filterData.unitType
				.map((item) => item.value)
				.join();
		if (filterData.bedrooms?.length)
			params["bedrooms"] = filterData.bedrooms.join();
		if (filterData.bathrooms?.length)
			params["bathrooms"] = filterData.bathrooms.join();
		if (filterData.delivery?.length) params["delivery"] = filterData.delivery;
		params["per_page"] = 12;

		setFilterParams({ ...params });
		setPage(1);
		if (
			filterData.compound?.label?.trim()?.length ||
			filterData.location ||
			filterData.paymentMethods?.length ||
			filterData.categories_ids?.length ||
			filterData.finishingType?.length ||
			filterData.unitType?.length ||
			filterData.bedrooms?.length ||
			filterData.bathrooms?.length ||
			filterData.delivery?.length
		) {
			// setExplore(true)
			setLoading(false);
		} else {
			setExplore(false);
		}
		// }, 500)

		// return () => clearTimeout(timeoutId)
	}, [filterData]);

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			if (!!filtersParams?.budget && !!filtersParams?.area_sizs) {
				if (
					filterData.compound?.type === "developer" ||
					filterData.compound?.type === "compound"
				) {
					homeService?.getDeveloperCompounds(filtersParams).then((response) => {
						setCompareListData(response?.data?.slice(0, 3));
						// setCompareListData(response?.data?.best_compounds?.slice(0, 3))
						let itemList = [];
						const filteredArray = response.data?.filter(
							(obj2) => !response?.data?.some((obj1) => obj1.id === obj2.id)
						);
						// const filteredArray = response.data.relevant_compounds?.data?.filter(obj2 => !response?.data?.best_compounds.some(obj1 => obj1.id === obj2.id));
						// if(response?.data?.best_compounds?.length > 3){
						if (response?.data?.length > 3) {
							itemList.push(...response?.data?.slice(3), ...filteredArray);
							// itemList.push(...response?.data?.best_compounds?.slice(3),...filteredArray)
						} else {
							itemList.push(...filteredArray);
						}
						// let totalPages = Math.ceil(response.data.relevant_compounds?.meta.total / 12)
						// let totalPages = Math.ceil(response.data.relevant_compounds?.meta.total / 12)
						// setPageOptions({...pageOptions, totalPages: totalPages})
						setTimeout(() => {
							updateFilteredData(itemList);
						}, 500);
					});
				} else {
					homeService?.getList(filtersParams).then((response) => {
						setCompareListData(response?.data?.best_compounds?.slice(0, 3));
						let itemList = [];
						const filteredArray =
							response?.data?.relevant_compounds?.data?.filter(
								(obj2) =>
									!response?.data?.best_compounds.some(
										(obj1) => obj1.id === obj2.id
									)
							);
						if (response?.data?.best_compounds?.length > 3) {
							itemList.push(
								...response?.data?.best_compounds?.slice(3),
								...filteredArray
							);
						} else {
							itemList.push(...filteredArray);
						}
						let totalPages = Math.ceil(
							response?.data?.relevant_compounds?.meta.total / 12
						);
						setPageOptions({ ...pageOptions, totalPages: totalPages });
						setTimeout(() => {
							updateFilteredData(itemList);
						}, 500);
					});
				}
			}
		}, 1500);
		return () => clearTimeout(timeoutId);
	}, [filtersParams]);

	const deleteCompound = (id) => {
		const deletedItem = compareListData.find((item) => item.id === id);
		const filteredList = compareListData.filter(
			(compound) => compound.id != id
		);
		setCompareListData([...filteredList]);
		setCompoundList([...compoundList, deletedItem]);
	};

	const AddToSelectedCompounds = (compoundData) => {
		if (compareListData?.length === 3) {
			toast.error(`${t("List Compare is Complete")}`);
			return;
		}

		const isExists = compareListData.every(
			(item) => item.id !== compoundData.id
		);
		if (!isExists) {
			toast.error(`${t("Already exists")}`);
			return;
		}

		const filteredList = compoundList.filter((compound) => {
			return compound.id !== compoundData.id;
		});
		setCompoundList([...filteredList]);
		setCompareListData([...compareListData, compoundData]);
	};

	useEffect(() => {
		const ids = compareListData?.map((item) => item.id);
		setIds(ids);
	}, [compareListData]);

	const updateFilteredData = (data) => {
		const updatedList = data?.filter(
			({ id }) => !compareListData?.some((item) => item.id === id)
		);
		setLoading(false);
		setCompoundList([...updatedList]);
	};

	const exploreMore = () => {
		if (compoundList.slice(page * 6, page * 6 + 6).length >= 6) {
			setPage(page + 1);
			return;
		}
		let pageOpt = pageOptions.page || 0;
		homeService
			?.getList({ ...filtersParams, page: pageOpt + 1 })
			.then((response) => {
				setPageOptions({ ...pageOptions, page: pageOpt + 1 });
				const filteredArray = response.data.relevant_compounds?.data?.filter(
					(item) => {
						const isLabelExist = response.data.best_compounds?.find(
							(item2) => item2.id === item.id
						);
						return !isLabelExist;
					}
				);
				setCompoundList([...compoundList, ...filteredArray]);
			});
		setPage(page + 1);
	};

	return (
		<React.Fragment>
			<Navbar />
			<div className="websitPages pt-10rem">
				<MetaTags>
					<title>{t("Advanced Filter Page")}</title>
				</MetaTags>
				<div>
					<Container fluid className="px-lg-5 pb-5">
						<Row className="justify-content-around">
							<Col
								lg={12}
								className="filter d-flex justify-content-center"
								style={{ gap: "12px" }}>
								<div
									className="col-xl-2 col-lg-3 col-md-2 filter-modal-button cursor-pointer"
									onClick={() => setModal(true)}>
									<img src={filterIcon} alt="filterIcon" />
									<span>Filter</span>
								</div>
								<div className="col-xl-8 col-lg-6 col-md-9 filter-search">
									<input
										type="text"
										placeholder="Search by area, Compound"
										name="search"
										onChange={(e) => {
											setSearch(e.target.value);
										}}
									/>
									<i
										className="fa fa-search"
										onClick={() => {
											dispatch(appendFilters({ compound: search }));
										}}
									/>
								</div>
							</Col>
							{modal && (
								<SideFilters
									modal={modal}
									toggle={() => setModal(false)}
									loading={loading}
									setLoading={setLoading}
									updateFilterHandler={(data) => {}}
									type="Compound"
								/>
							)}
							<Col lg={12}>
								<div className="py-4 mb-3">
									<Row className="mb-4">
										<Col md={8} className="d-flex align-items-center">
											<CardText
												dangerouslySetInnerHTML={{
													__html: t("Compare Projects"),
												}}
												className="text-primary font-size-24 pb-3 pb-md-0"
												tag="h4"></CardText>
										</Col>
										<Col
											md={4}
											className="d-flex flex-lg-row-reverse pb-3 pb-md-0">
											<button
												onClick={() => {
													if (
														compareListData?.length <= 3 &&
														compareListData?.length > 1
													) {
														dispatch(appendFilters({ comparedIds: ids }));
														if (
															AuthData.token &&
															AuthData.userType === "user"
														) {
															props?.history.push(`/compare-list`);
														} else {
															dispatch(
																authenticate({ navigateTo: `/compare-list` })
															);
															props?.history.push(`/login`, {
																navigateTo: `/compare-list`,
															});
														}
													} else {
														toast.error(
															`${t(
																"Compare List should have be at least in 2 Compounds"
															)}`
														);
													}
												}}
												type="button"
												className="btn btn-primary float-lg-end px-4  fw-bold font-size-16 "
												style={{
													background: "white",
													color: "#fff",
													borderRadius: "25px",
													// boxShadow: "0 3px 8px 0 rgba(21, 131, 242, 0.16)",
												}}>
												{t("compare")}
											</button>
										</Col>
									</Row>
									<Row className="pt-3">
										{compareListData?.length !== 0
											? compareListData?.map((item, index) => {
													if (index <= 2) {
														return (
															<Col
																xl={4}
																md={6}
																className="p-0 mb-4"
																key={index}>
																<CompoundCard
																	compound={item}
																	deleteCompound={deleteCompound}
																	history={props.history}
																	loaction={props.loaction}
																/>
															</Col>
														);
													}
											  })
											: null}
									</Row>
								</div>
								<Row className="mb-3">
									<Col md={10}>
										<CardText
											tag="h4"
											className="text-primary font-size-24"
											style={{ color: "#0583f2" }}>
											{t("another result")}
										</CardText>
									</Col>
									{/* {!explore && } */}
								</Row>
								<Row
									className={classnames("position-relative", {
										listdir: AuthData.lang === "ar",
									})}>
									{/* replace 100 to 2 if we want to show  Carousel   */}
									{/* {compoundList?.length >= 100 ?
                    <Carousel
                      className='p-3 mb-4'
                      style={{ paddingTop: "20px !important" }}
                      swipeable={true}
                      draggable={true}
                      showDots={true}
                      responsive={responsive}
                      infinite={false}
                      autoPlaySpeed={1000}
                      keyBoardControl={true}
                      customTransition='all .5'
                      transitionDuration={500}
                      customRightArrow={<CustomRight />}
                      customLeftArrow={<CustomLeft />}
                      containerClass='carousel-container'
                      dotListClass='custom-dot-list-style'
                      itemClass='carousel-item-padding-40-px'>
                      {compoundList.map((item, index) => {
                        return (
                          <CardItem
                            key={index}
                            compound={item}
                            AddToSelectedCompounds={AddToSelectedCompounds}
                            history={props.history}
                          />
                        )
                      })}
                    </Carousel> } */}

									{compoundList?.map((item, index) => {
										if (index < page * 6) {
											return (
												<Col xl={4} md={6} className="pb-3" key={index}>
													<CardItem
														key={index}
														compound={item}
														AddToSelectedCompounds={AddToSelectedCompounds}
														history={props.history}
													/>
												</Col>
											);
										}
									})}
								</Row>
								{pageOptions.totalPages >= pageOptions.page &&
									!!compoundList?.length && (
										<Col xl={1} md={2} className="m-auto mt-4">
											<span
												className="btn-hover btn-primary font-size-14 explore-btn d-flex justify-content-center align-items-center"
												style={{
													background: "var(--primary-color)",
													color: "#fff",
													padding: "8px 18px",
												}}
												onClick={() => {
													// props.history.push("/compounds")
													// setExplore(true)
													exploreMore();
													// let params ={}
													// params["budget"] = `${Math.round(filterData.budget[0])}-${Math.round(filterData.budget[1])}`
													// params["area_sizs"] = `${Math.round(filterData.size[0])}-${Math.round(filterData.size[1])}`
													// setFilterParams(params)
												}}>
												{/* <i className="fa fa-search me-2"></i> */}
												{t("See More")}
											</span>
										</Col>
									)}
							</Col>
						</Row>
						<Row className="d-flex justify-content-end">
							<Col className="d-flex justify-content-end" md={8} sm={12}>
								{/* {<Paginator
                  // service={homeService}
                  pageOptions={pageOptions}
                  // setData={(data) => {
                  //   updateFilteredData(data)
                  // }}
                  explore={explore}
                  setPageOptions={setPageOptions}
                  // filtersParams={filtersParams}
                  // compareListData={compareListData}
                  // setCompareListData={(compData) => {
                  //   // if (filterData.comparedIds?.length === 0) {
                  //     if (compData?.length) {
                  //       if (compData?.length <= 3) {
                  //         setCompareListData([...compData])
                  //       } else if (compData?.length > 3) {
                  //         const updadedData = compData.slice(0, 3)
                  //         setCompareListData([...updadedData])
                  //       }
                  //     } else {
                  //       setCompareListData([])
                  //     }
                  //   // }
                  // }}
                  // setPage={setPage}
                  compoundList={compoundList}
                />} */}
							</Col>
						</Row>
					</Container>
				</div>
				<HearForm />
			</div>
			{/* <AuthCard modal={modal} setModal={setModal} history={props.history} location={props.location} /> */}
			<Footer />
		</React.Fragment>
	);
};

const CustomRight = ({ onClick }) => (
	<button onClick={onClick} className="bg-white arrow right border-0">
		<i className="fas fa-arrow-alt-circle-right text-primary fa-2x"></i>
	</button>
);
const CustomLeft = ({ onClick }) => (
	<button onClick={onClick} className="bg-white arrow left border-0">
		<i className="fas fa-arrow-alt-circle-left text-primary fa-2x"></i>
	</button>
);

const responsive = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 3000 },
		items: 5,
		slidesToSlide: 3,
	},
	desktop: {
		breakpoint: { max: 3000, min: 1100 },
		items: 3,
		slidesToSlide: 3,
	},
	tablet: {
		breakpoint: { max: 1100, min: 767 },
		items: 2,
		slidesToSlide: 2,
	},
	mobile: {
		breakpoint: { max: 767, min: 0 },
		items: 1,
		slidesToSlide: 1,
	},
};
export default AdvancedFilter;
